import { initComponent } from './core/init-component.js'

initComponent('.js-pdp-accordion', section => {
  const accordionItems = section.querySelectorAll('.js-accordion-item')
  const faqsTrigger = section.querySelector('.js-accordion-item-faqs')
  const faqsDrawer = document.querySelector('#pdp__faqs-drawer')
  const faqsOverlay = document.querySelector('#pdp__faqs-overlay')
  const closeDrawerButton = document.querySelector('.js-faqs-drawer-close')

  const closeAccordionItem = item => {
    const content = item.nextElementSibling
    if (!content || !content.classList.contains('js-accordion-content')) return

    const plusIcon = item.querySelector('.accordion-icon-plus, .faq-icon-plus')
    const minusIcon = item.querySelector('.accordion-icon-minus, .faq-icon-minus')

    content.style.height = '0'
    content.classList.remove('pt-lg')
    item.classList.remove('open')
    content.style.overflow = 'auto'
    content.setAttribute('hidden', '')
    item.setAttribute('aria-expanded', 'false')

    if (plusIcon && minusIcon) {
      plusIcon.classList.remove('hidden')
      minusIcon.classList.add('hidden')
    }
  }

  const openAccordionItem = item => {
    const content = item.nextElementSibling
    if (!content || !content.classList.contains('js-accordion-content')) return

    const plusIcon = item.querySelector('.accordion-icon-plus, .faq-icon-plus')
    const minusIcon = item.querySelector('.accordion-icon-minus, .faq-icon-minus')

    content.removeAttribute('hidden')
    const savedTransition = content.style.transition
    content.style.transition = 'none'
    content.style.height = 'auto'
    const height = content.offsetHeight
    content.style.height = '0px'
    void content.offsetHeight
    content.style.transition = savedTransition
    content.style.height = height + 16 + 'px'
    content.classList.add('pt-lg')
    item.classList.add('open')
    item.setAttribute('aria-expanded', 'true')

    setTimeout(() => {
      content.style.overflow = ''
    }, 300)

    if (plusIcon && minusIcon) {
      plusIcon.classList.add('hidden')
      minusIcon.classList.remove('hidden')
    }
  }

  accordionItems.forEach(item => {
    const isFaqsItem = item.classList.contains('js-accordion-item-faqs')

    if (isFaqsItem) {
      item.addEventListener('click', () => {
        if (faqsDrawer && faqsOverlay) {
          faqsDrawer.classList.add('is-open')
          faqsOverlay.classList.add('is-open')
          document.body.style.overflow = 'hidden'
          item.setAttribute('aria-expanded', 'true')
        }
      })
    } else {
      const content = item.nextElementSibling
      if (!content || !content.classList.contains('js-accordion-content')) return

      content.style.transition = 'all 0.3s ease-in-out'

      item.addEventListener('click', () => {
        const isOpen = item.classList.contains('open')

        accordionItems.forEach(otherItem => {
          if (otherItem !== item && !otherItem.classList.contains('js-accordion-item-faqs')) {
            closeAccordionItem(otherItem)
          }
        })

        if (isOpen) {
          closeAccordionItem(item)
        } else {
          openAccordionItem(item)

          if (window.innerWidth < 1024) {
            setTimeout(() => {
              const content = item?.nextElementSibling
              if (!content) return

              const headerHeight = parseInt(
                getComputedStyle(document.documentElement).getPropertyValue('--hh-total-header-height')
              ) || 0
              const rect = content.getBoundingClientRect()
              const isInView = rect.top >= headerHeight && rect.bottom <= window.innerHeight

              if (!isInView) {
                content.style.scrollMarginBottom = '1rem'
                content.scrollIntoView({ behavior: 'smooth', block: 'end' })
              }
            }, 300)
          }
        }
      })
    }
  })

  const closeDrawer = () => {
    if (faqsDrawer && faqsOverlay) {
      faqsDrawer.classList.remove('is-open')
      faqsOverlay.classList.remove('is-open')
      document.body.style.overflow = ''
      if (faqsTrigger) {
        faqsTrigger.setAttribute('aria-expanded', 'false')
      }
    }
  }

  if (closeDrawerButton) {
    closeDrawerButton.addEventListener('click', closeDrawer)
  }

  if (faqsOverlay) {
    faqsOverlay.addEventListener('click', closeDrawer)
  }

  return {
    unload() {
      if (closeDrawerButton) {
        closeDrawerButton.removeEventListener('click', closeDrawer)
      }
      if (faqsOverlay) {
        faqsOverlay.removeEventListener('click', closeDrawer)
      }
    }
  }
});
